module.exports = __webpack_public_path__ + "media/mypage/images/menu/spm1-7857a510a87ba742e5a2207f1dd06bb8.png";